import {VehicleDriverHistoryExcludeDigitalSignatureTypeEnum} from '@/services/api-clients';
export function excludeTypeFromRequiredDigitalSignatureColorFilter(type?: VehicleDriverHistoryExcludeDigitalSignatureTypeEnum, isTransfer: boolean = false): string[] {
  const typesToCheck:  VehicleDriverHistoryExcludeDigitalSignatureTypeEnum[] = [ VehicleDriverHistoryExcludeDigitalSignatureTypeEnum.All, isTransfer
    ? VehicleDriverHistoryExcludeDigitalSignatureTypeEnum.Transfer
    : VehicleDriverHistoryExcludeDigitalSignatureTypeEnum.Receive ];


  if (!type || !typesToCheck.includes(type)) return ['primary', 'primary--text'];

  return ['warning', 'warning--text'];
}
